import type { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";
import { formatDimension } from "src/utils/formatDimension";

export interface MerchandisableSpaceInfo {
  merchandisableWidth: number;
  width: number;
}

/**
 * Merge-aware: a merged group's effective width/merchandisableWidth reduce to a single
 * shelf's own width/merchandisableWidth when the shelf isn't merged. Returns null when the
 * shelf is fully merchandisable, since that state isn't worth surfacing as extra UI.
 */
export const getMerchandisableSpaceInfo = (
  shelf: PlanogramShelf,
): MerchandisableSpaceInfo | null => {
  const width = shelf.getMergedWidth();
  const merchandisableWidth = shelf.getMergedMerchandisableWidth();

  return merchandisableWidth < width ? { merchandisableWidth, width } : null;
};

export const formatMerchandisableSpace = ({
  merchandisableWidth,
  width,
}: MerchandisableSpaceInfo) =>
  `${formatDimension(merchandisableWidth)} / ${formatDimension(width)}`;
